@let hasLabels = this.hasLabels();
@let labels = this.labels();
@let steps = this.steps();
@let selectedIndex = this.selectedIndex();
@let debug = this.debug();
@let processTitle = this.processTitle();

@if (hasLabels) {
  <nav class="pt-5" aria-label="{{ processTitle | translate }}">
    <ol
      class="step-navigation"
      [ngClass]="{ 'step-navigation-one-label': layoutOneLabel(), 'step-navigation-wrap-label': layoutWrapLabel() }"
      [style.--step-navigation-steps-count]="labels?.length || steps?.length"
      [style.--step-navigation-steps-complete]="selectedIndex"
    >
      @for (label of labels; track $index) {
        @let id = 'progress-bar-step-' + $index;
        @let isCurrent = $index === selectedIndex;
        @let status = getStatus($index, isCurrent) | translate;
        @let isDisabled = $index > selectedIndex;

        <li class="step-navigation-listitem">
          <div
            class="step-navigation-step rounded-3"
            [id]="id"
            [class.step-navigation-step-complete]="$index < selectedIndex"
            [class.step-navigation-step-active]="isCurrent"
            [class.step-navigation-step-disabled]="isDisabled"
            [attr.aria-current]="isCurrent ? 'step' : null"
          >
            <div class="step-navigation-step-counter" aria-hidden="true"></div>
            <div class="step-navigation-step-label text-center" aria-hidden="true">
              {{ label | translate }}
            </div>
            <span class="visually-hidden">{{ label | translate }} {{ status }}</span>
          </div>
        </li>
      }

      @for (step of steps; track $index) {
        @let id = 'progress-bar-step-' + $index;
        @let label = step.label$ | async | translate;
        @let isCurrent = $index === selectedIndex;
        @let isFocusable = isCurrent ? false : (step.focusable$ | async);
        @let status = getStatus($index, isCurrent) | translate;
        @let isDisabled = !isCurrent && !isFocusable;

        <li class="step-navigation-listitem">
          <div
            class="step-navigation-step rounded-3"
            (keydown)="isFocusable && onKeyDown($event, step.step)"
            [id]="id"
            [class.step-navigation-step-complete]="$index < selectedIndex"
            [class.step-navigation-step-active]="isCurrent"
            [class.step-navigation-step-focusable]="isFocusable"
            [class.step-navigation-step-disabled]="isDisabled"
            [attr.tabIndex]="isFocusable ? 0 : null"
            [attr.role]="isFocusable ? 'button' : null"
            [attr.aria-current]="isCurrent ? 'step' : null"
          >
            <div class="step-navigation-step-counter" aria-hidden="true"></div>
            <div class="step-navigation-step-label step-navigation-step-label-normal" aria-hidden="true">
              {{ label | translate }}

              @if (debug) {
                <br />
                {{ (step.canSkip$ | async) ? 'skip +' : 'skip X' }} | {{ (step.depsFulfilled$ | async) ? 'deps +' : 'deps X' }}
                <br />
                {{ (step.canEnter$ | async) ? 'canEnter' : 'cannotEnter' }}
                <br />
                {{ step.stateTags }}
              }
            </div>
            <div class="step-navigation-step-label step-navigation-step-label-wrapped" aria-hidden="true">
              {{ label | translate }}

              @if (debug) {
                <br />
                {{ (step.canSkip$ | async) ? 'skip +' : 'skip X' }} | {{ (step.depsFulfilled$ | async) ? 'deps +' : 'deps X' }}
                <br />
                {{ (step.canEnter$ | async) ? 'canEnter' : 'cannotEnter' }}
                <br />
                {{ step.stateTags }}
              }
            </div>
            <span class="visually-hidden">{{ label | translate }} {{ status }}</span>
          </div>
        </li>
      }
    </ol>
  </nav>
}
